import { render, staticRenderFns } from "./AmpifireLayout.vue?vue&type=template&id=74d6648e&"
import script from "./AmpifireLayout.vue?vue&type=script&lang=ts&"
export * from "./AmpifireLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports